import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";

export default function CategorySection() {
  return (
    <section className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs tracking-[0.3em] text-primary-400">ARCHIVE INDEX</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">按题材翻阅档案</h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400">
            六个长期栏目，覆盖从旧案卷宗到深夜口述的全部题材。选择一个方向，直接进入对应档案分区。
          </p>
        </div>
        <Link
          to="/archives"
          className="flex w-fit items-center gap-1.5 whitespace-nowrap text-sm text-primary-400 transition-colors hover:text-primary-300"
        >
          查看全部档案 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category, index) => (
          <Link
            key={category.slug}
            to={`/archives?category=${category.slug}`}
            className="group relative flex flex-col overflow-hidden rounded-lg border border-background-800 bg-background-900 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40 md:p-6"
          >
            <span className="absolute right-4 top-4 font-heading text-4xl font-black text-background-800 transition-colors group-hover:text-primary-500/20">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span className="flex h-11 w-11 items-center justify-center rounded-md border border-secondary-500/40 bg-secondary-500/10 text-secondary-300">
              <i className={`${category.icon} text-xl`} />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-50 transition-colors group-hover:text-primary-300">
              {category.name}
            </h3>
            <p className="mt-1 text-xs text-accent-300">{category.tagline}</p>
            <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-400">{category.desc}</p>
            <p className="mt-4 flex items-center gap-2 border-t border-background-800 pt-3 text-xs text-foreground-500">
              <i className="ri-archive-line" /> 已公开 {getArticlesByCategory(category.slug).length} 篇 · 持续更新
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}